import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './MortgageOffersHeaderRow.css';

export const MortgageOffersHeaderRow: React.FC = () => {
  return (
    <div className={styles['row']}>
      <div className={styles['main']}>
        <UIText2 color="text-primary-disabled">Банки и застройщики</UIText2>
      </div>
      <div className={styles['rate']}>
        <UIText2 color="text-primary-disabled">Ставка</UIText2>
      </div>
      <div className={styles['sum']}>
        <UIText2 color="text-primary-disabled">Сумма</UIText2>
      </div>
      <div className={styles['term']}>
        <UIText2 color="text-primary-disabled">Срок</UIText2>
      </div>
      <div className={styles['payment']}>
        <UIText2 color="text-primary-disabled">Ежемесячный платёж</UIText2>
      </div>
    </div>
  );
};
